<div class="modal-header modal-header-custom">
  <h4 class="modal-title text-center modal-title-custom">User Access Information</h4>
  <button type="button" class="btn btn-warning btn-lg btn-close-custom" aria-label="Close" (click)="close()">
    <i class="fas fa-window-close"></i>
  </button>
</div>

<div class="modal-body modal-body-custom">
  <h4>Roles and Modules</h4>
  <br>
    <mat-accordion class="user-access-accordion">
      @for (role of userRolesMapped; track role) {
        <div>
          <mat-expansion-panel [expanded]="false">
            <mat-expansion-panel-header>
              <mat-panel-title class="panel-title-custom">
                {{ role.roleDescription }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            @if (role.rpfDetails.length > 0) {
              <div class="approvers-list">
                <div class="rpf-title">RPF Details:</div>
                <ul>
                  @for (rpf of role.rpfDetails; track rpf) {
                    <li class="rpf-item">
                      (ID: {{ rpf.rpfId }}) {{ rpf.rpfName }}
                    </li>
                  }
                </ul>
              </div>
            }
            <!-- Modules -->
            @for (module of role.modules; track module) {
              <div>
                <mat-expansion-panel [disabled]="true">
                  <mat-expansion-panel-header class="module-header-custom">
                    <mat-panel-title class="panel-title-custom">
                      {{ module.module_Name }}
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <!-- Approvers -->
                  @if (module.approvers.length > 0) {
                    <div class="approvers-list">
                      <h4>Approvers:</h4>
                      <ul>
                        @for (approver of module.approvers; track approver) {
                          <li>
                            {{ approver.approverRoleDescription }}
                          </li>
                        }
                      </ul>
                    </div>
                  }
                </mat-expansion-panel>
              </div>
            }
          </mat-expansion-panel>
        </div>
      }
    </mat-accordion>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-yellow-filled" data-dismiss="modal" (click)="close()">Close</button>
  </div>
